import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../panels/BasePanelPage";
import {Messages} from "../../../../Messages";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {PaywallToast} from "../../../PaywallToast";
import {MerchantButton} from "../../../../common/MerchantButton";
import {addressController} from "../../../inline-subscription/AddressController";
import {apiDeleteAddress, UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {InlineUserDashboardPanelStyle} from "./InlineUserDashboardPanelStyle";


@autoredraw(UserAddressStore)
@registerStyle(InlineUserDashboardPanelStyle)
export class InlineUserDashboardRemoveAddressPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.removeAddress,
        };
    }

    async removeAddress() {
        LoadingSpinner.show();
        try {
            await apiDeleteAddress(addressController.selectedAddress.id);
            Router.back();
            PaywallToast.showSuccess(Messages.addressRemoved);
        } catch (error) {
            PaywallToast.showError(error.message);
        } finally {
            LoadingSpinner.hide();
        }
    }

    render() {
        const {styleSheet} = this;

        return [
            <MessageElement message={Messages.deleteAddressDescription(addressController.selectedAddress.toString())}/>,
            <MerchantButton className={styleSheet.button} label={Messages.remove} onClick={() => this.removeAddress()}/>,
            <div className={styleSheet.center}>
                <div className={styleSheet.secondaryButton} onClick={() => Router.back()}>
                    {Messages.cancel}
                </div>
            </div>
        ];
    }
}
